import { createBrowserHistory } from 'history';

/**
 * Creates a running Browser history for router to take advantage of
 * see: https://github.com/ReactTraining/react-router/blob/v3/modules/browserHistory.js
 */
export default createBrowserHistory();
